import { useDiariesForTodoCounters } from "@/features/diaries/hooks/useDiariesForTodoCounters";
import { useAuth } from "@/utils/auth";

import { usePatientJourney } from "./usePatientJourney";

/**
 * Patient nav badges — thin wrapper around {@link usePatientJourney} +
 * {@link computePatientNotifications} in journeyTodos.ts (single source of truth).
 * Profile badge = pre-form journey work; Diaries badge = due form entries.
 */
export function usePatientNotificationCounts() {
    const auth = useAuth();
    const isPatient = auth.roles?.isPatient === true;
    const patientId = isPatient && auth.id ? auth.id : "";
    const diaries = useDiariesForTodoCounters(patientId);
    const primaryDiary = isPatient ? (diaries[0] ?? null) : null;
    const journey = usePatientJourney(primaryDiary, { allDiaries: isPatient ? diaries : [] });
    const notifications = journey.notifications;

    return {
        profileBadgeCount: notifications?.profileBadgeCount ?? 0,
        diariesBadgeCount: notifications?.diariesBadgeCount ?? 0,
        formEntryCount: notifications?.formEntryCount ?? 0,
        formItemCount: notifications?.formItemCount ?? 0,
    };
}

export function NavNotificationBadge({ count }: { count: number }) {
    if (count === 0) {
        return null;
    }

    return (
        <span className="flex justify-center items-center bg-red-400 shadow-sm px-1 rounded-full min-w-5 h-5 font-medium text-white text-xs">
            {count > 99 ? "99+" : count}
        </span>
    );
}
